import check from "Explore/Assets/check.png";
import {
  AutoCompleteSearch,
  ImageCheck,
  LinkWrapper,
  LoadingListEntityProfile,
} from "Explore/Components";
import { Empty, Tag } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./VenueTopScholars.module.scss";
import { IconPack } from "Explore/Config/Icons";
import { numberRegex } from "Explore/Utils/numberRegex";
import { ImageCheckType } from "Explore/Config/ImageType";
import { useEffect, useState } from "react";
import { getVenueTopAuthorsSuggestion } from "Explore/Services/Venue";
import useExploreInfo from "Hooks/useExploreInfo";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import { ParamsFilterKey } from "Config/filterSearchParams";
import getScholarDescription from "./getScholarDescription";

const Peer = ({ peer, index }) => {
  const statistics = [
    {
      title: "h-index",
      value: peer.specific_stats.h_index,
      icon: IconPack.h_index,
    },
    {
      title: "citations",
      value: peer.specific_stats.citation_count,
      icon: IconPack.citation,
    },
    {
      title: "publications",
      value: peer.specific_stats.publication_count,
      icon: IconPack.publications,
    },
  ];

  return (
    <div className={styles["peer"]}>
      {!!peer.specific_stats.rank && (
        <div className={styles["peer__left"]}>
          <div className={styles["ranking"]}>
            <span>#</span>
            <span className={styles["ranking--index"]}>
              {peer.specific_stats.rank}
            </span>
          </div>
        </div>
      )}
      <div className={styles["peer__right"]}>
        <div className={styles["peer__right__top"]}>
          <div className={styles["avatar"]}>
            <ImageCheck
              url={peer.photo}
              className={styles["photo"]}
              alt={"avatar"}
              type={ImageCheckType.FACULTY_AVATAR}
            />
          </div>

          <div className={styles["info"]}>
            <div className={styles["info__top"]}>
              <LinkWrapper
                component={
                  <div>
                    <p className={styles["name"]}>{peer.name}</p>
                  </div>
                }
                link={`/explore/faculty/${peer.explore_slug || peer.id}`}
              />

              <div className={styles["score"]}>
                {IconPack.score}
                <span>Score:</span>&nbsp;{Math.round(peer.score * 100) / 100}
              </div>
            </div>

            <LinkWrapper
              link={`explore/institution/${peer.institution.explore_slug || peer.institution.id}`}
              component={
                <p className={styles["inst-name"]}>{peer.institution.name}</p>
              }
            />
            {/* <p className={styles["position"]}>{getScholarDescription(peer)}</p> */}
          </div>
        </div>
        <div className={styles["peer__right__bottom"]}>
          {/* <div className={styles["statistics"]}>
            {statistics
              .filter((e) => !!e.value)
              .map(({ title, value, icon }) => (
                <div className={styles["statistics__item"]} key={title}>
                  <div className={styles["statistics__item--icon"]}>{icon}</div>
                  <div className={styles["statistics__item--content"]}>
                    <p className={styles["statistics__item--value"]}>
                      {numberRegex(value)}
                    </p>
                    <p className={styles["statistics__item--title"]}>{title}</p>
                  </div>
                </div>
              ))}
          </div> */}
          <div className={styles["tags"]}>
            {peer.keywords.map((item, index) => {
              return (
                <Tag
                  key={index}
                  color="var(--light-blue)"
                  style={{ color: "var(--dark-grey)" }}
                >
                  {item.id}
                </Tag>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const VenueTopScholars = ({ data, isLoading, pagination }) => {
  const { filter: _filter, updateSearchParams } = useFilterAndPagination();
  const { venue_id } = useExploreInfo();
  const [filter, setFilter] = useState({ query: "" });

  useEffect(() => {
    if (!!filter.query) {
      updateSearchParams({ [ParamsFilterKey.QUERY]: [filter.query] });
    } else {
      updateSearchParams({ [ParamsFilterKey.QUERY]: [] });
    }
  }, [filter.query]);

  return (
    <div className={styles["venue-top-scholars"]}>
      <LoadingListEntityProfile
        isLoading={isLoading}
        component={
          data.length > 0 ? (
            data?.map((item, index) => {
              return (
                <Peer
                  peer={item}
                  key={index}
                  index={index + (pagination.page - 1) * pagination.rowsPerPage}
                />
              );
            })
          ) : (
            <Empty description="No scholar Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />
    </div>
  );
};
export default VenueTopScholars;
